import { Box, Typography } from '@mui/material';
import { useAuth } from '../auth/auth-hook';
import { getPostUrl } from '../auth/auth-utils';
import { Plan, useCheckoutTipsMutation } from '../../shared/types/generated';
import { useState } from 'react';
import { triggerEvent } from '../remote-education/remote-education-utils';

interface StripeButtonProps {
  plan?: Plan;
}

export const StripeButtonWithoutStoreTipsBanner: React.FC<
  StripeButtonProps
> = ({ plan }) => {
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();

  const [callCheckout] = useCheckoutTipsMutation({
    onCompleted: (data) => {
      if (!data.checkoutTips?.redirect_url) return;
      window.location.href = data.checkoutTips.redirect_url;
    },
    onError: (error) => {
      setLoading(false);
      console.log(error);
    },
  });

  const handleCheckout = (): void => {
    if (!plan?.stripe) {
      return;
    }

    callCheckout({
      variables: {
        data: {
          email: user?.email,
          priceId: plan.stripe?.price_id || '',
          stateUrl: `post_url=${getPostUrl()}`,
          metadata: {
            //subscriptionBilling: JSON.stringify(subscriptionBilling),
            post_url: getPostUrl(),
          },
          //coupon: coupon?.coupon ?? undefined,
        },
      },
    });
  };

  if (!plan?.stripe) {
    return (
      <Typography variant="subtitle1" fontWeight={800} textAlign="center">
        Stripe no esta configurado para este plan, contacte a su administrador
      </Typography>
    );
  }

  return (
    <>
      {loading ? (
        <Box
          position={'fixed'}
          zIndex={99999999}
          top={0}
          aria-label=""
          left={0}
          width={'100%'}
          height={'100%'}
          component={'div'}
          sx={{ '-webkit-backdrop-filter': 'blur(10px) brightness(0.8)' }}
          style={{
            backdropFilter: 'blur(10px) brightness(0.8)',
            background: 'rgba(0, 0, 0, 0.3)',
          }}
        >
          <Box
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
            height={'100%'}
          >
            <Typography fontFamily={'manop'} color={'white'} fontSize={'32px'}>
              Procesando, por favor espere…
            </Typography>
          </Box>
        </Box>
      ) : null}
      <Box display={'flex'} justifyContent={'center'}>
        <Box
          onClick={() => {
            //return;
            setLoading(true);
            triggerEvent('btn_ae');
            handleCheckout();
          }}
          borderRadius={'5px'}
          paddingY={'40px'}
          flex={1}
          width={{ xs: '100%' }}
          maxWidth={{ xs: '1250px' }}
          height={{ xs: 'auto' }}
          style={{
            textDecoration: 'none',
            //backgroundColor: 'black',
            cursor: 'pointer',
          }}
        >
          <Box
            component={'img'}
            src="https://digitalroom.nyc3.cdn.digitaloceanspaces.com/animal-politico-auxiliar/banner_suscripciones-big.png"
            sx={{ height: '100%', width: '100%' }}
          />
        </Box>
      </Box>
    </>
  );
};
